export const constants = {
  APP_TITLE: 'AgilOps Lite',
  SIZES_SESSION_KEY: 'dashboard-panel-sizes',
  DEFAULT_COORD: [103.8198, 1.3521],
  LANGUAGES: {
    ENGLISH: 'English',
    DEUTSCH: 'Deutsch',
    BAHASA_INDONESIA: 'Bahasa Indonesia',
    ESPAÑOL_LATINOAMÉRICA: 'Español (Latinoamérica)',
    PORTUGUÊS_BRASIL: 'Português (Brasil)',
    ΕΛΛΗΝΙΚΆ: 'Ελληνικά',
    VIETNAMESE: 'Vietnamese',
  },
  HEADER: {
    USERNAME: 'username',
    MODE: 'mode',
    SETTINGS: 'settings',
    LOG_OUT: 'log out',
    TITLE: 'AGIL Field Ops',
  },
  DASHBOARD: {
    INCIDENTS: 'incidents',
    INCIDENTS_NO_DATA: 'To create an incident, click "+ Create Incident " button',
    RESPONDERS: 'responders',
    RESPONDERS_NO_DATA: 'No alerts generated by the system.',
    CHAT: 'chat',
    ALERTS: 'alerts',
    ALERTS_NO_DATA: 'No alerts generated by the system.',
    UPDATES: 'updates',
    UPDATES_NO_DATA: 'No updates on the incident or responders.',
    NEW_MESSAGE_FROM: 'New message from',
    INCIDENT_UPDATED_BY: 'Incident updated by',
    NEW_INCIDENT_CREATED_BY: 'New Incident created by',
    PROFILE: 'profile',
    SUMMARY: 'summary',
    GENERATING_SUMMARY: 'generating summary...',
    DEFAULT_SIZES: {
      leftSidebarPan: {
        value: 40,
        incidentPan: 70,
        responsePan: 30,
      },
      rightSidebarPan: {
        value: 60,
        mapPan: 50,
        chatPan: 50,
      },
    },
  },
  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'incident name',
    INCIDENT_TYPE: 'incident type',
    ASSIGNEES: 'assignee(s)',
    SEVERITY: 'severity',
    STATUS: 'status',
    PTT: 'PTT',
    LOCATION: 'location',
    SEVERITY_CRITICAL: 'critical',
    SEVERITY_HIGH: 'high',
    SEVERITY_MEDIUM: 'medium',
    SEVERITY_LOW: 'low',
    SEVERITY_MINIMAL: 'minimal',
    REPORTED_DATE_TIME: 'Reported Date and Time',
    REPORTED_NAME: 'Reported Name',
    DESCRIPTION: 'description',
    RESPONDERS: 'responder(s)',
    ATTACHMENTS: 'attachments',
    LOCATION_DESCRIPTION: 'location description',
    NO_RESPONDERS_ASSIGNED: 'No Responders Assigned for the incident.',
  },
  TAB_KEYS: {
    ALL: 'all',
    UNREAD: 'unread',
    ACTIVE: 'active',
    CLOSED: 'closed',
    AVAILABLE: 'available',
    OFFLINE: 'offline',
    TAB_VALUE_UNACKNOWLEDGED: 'unacknowledged',
    TAB_VALUE_CREATED: 'created',
    TAB_VALUE_PROGRESS: 'progress',
    TAB_VALUE_IN_PROGRESS: 'in_progress',
    TAB_VALUE_RESOLVED: 'resolved',
  },
  RESPONDERS: {
    NAME: 'Name',
    GROUP_NAME: 'Group Name',
    PRESENCE: 'Presence',
    PERMISSION: 'Permission',
    STATUSES: 'Statuses',
    // Add responder list specific constants
    LIST: {
      COLUMNS: [
        { header: 'Name', accessorKey: 'displayName' },
        { header: 'Group Name', accessorKey: 'groupName' },
        {
          header: 'Presence',
          accessorKey: 'presence',
          filterFn: (row, columnId, filterValue) => {
            const value = row?.getValue(columnId);
            if (Array?.isArray(filterValue)) {
              return filterValue?.includes(value);
            }
            return value === filterValue;
          },
        },
        { header: 'Permission', accessorKey: 'permission' },
        { header: 'Statuses', accessorKey: 'statuses' },
      ],
      TABS: [
        { key: 'all', label: 'All' },
        // { key: 'active', label: 'Active' },
        { key: 'available', label: 'Available' },
        // { key: 'offline', label: 'Offline' },
      ],
      PRESENCE_STATUS: {
        DISCONNECTED: 'disconnected',
        OFFLINE: 'offline',
        ONLINE: 'online',
        AVAILABLE: 'available',
        UNAVAILABLE: 'unavailable',
      },
      STATUS_COLORS: {
        DISCONNECTED: 'bg-error-strong',
        OFFLINE: 'bg-icon-muted',
        ONLINE: 'bg-success-strong',
        AVAILABLE: 'bg-success-strong',
      },
      NO_DATA: {
        ALL: 'No responder found',
        FILTERED: 'No {status} responder found',
      },
      GRID_CONFIG: {
        MULTIPLE_ROWS: 'grid-cols-[repeat(auto-fit,minmax(200px,1fr))] justify-between',
        FEW_ROWS: 'grid-cols-[repeat(auto-fit,minmax(200px,max-content))] justify-start',
      },
    },
    UPDATE_STATUS: 'Update Status:',
    SHOW_LESS: 'Show less',
    STATUS_HISTORY: 'Status History',
    SHOW: 'Show',
    MORE: 'more',

    STATUS: {
      STATUS_KEY: {
        PENDING: 'pending',
        REJECTED: 'rejected',
        REACH_SITE: 'Reach site',
        ON_THE_WAY: 'On the way',
        DONE: 'Done',
        ABORTED: 'aborted',
      },
      STATUS_VALUE: {
        UNACKNOWLEDGED: 'Unacknowledged',
        REJECTED: 'Rejected',
        ARRIVED_AT_SCENE: 'Arrived at scene',
        ON_THE_WAY: 'On the way',
        ABORTED: 'Aborted',
      },
    },
  },
  MAPS: {
    VIEW_MODE: 'View Mode',
    DEFAULT: 'Default',
    SATELLITE: 'Satellite',
    FILTER_BY: 'Filter By',
    INCIDENTS: 'Incidents',
    ALL: 'All',
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
    RESPONDERS: 'Responders',
    ACTIVATED: 'Activated',
    AVAILABLE: 'Available',
    OFFLINE: 'Offline',
    DARK_MODE: 'Dark Mode',
    LIGHT_MODE: 'Light Mode',
    INCIDENTTYPE: 'Incident Type',
    REPORTEDDATE: 'Reported Date',
    SEVERITY: 'Severity',
    STATUS: 'Status',
    NO_RESPONDERS: 'No responders available',
  },
  NO_DATA: {
    CREATE_INCIDENT: 'Create Incident',
    NO: 'No',
    DATA_FOUND: 'Data Found',
    NO_OPTIONS: 'No options available',
  },
  PLACEHOLDER: {
    SELECT_OPTION: 'Select an option...',
    LOCATION: 'Enter a city, address, or place...',
    DESCRIPTION: 'Description of the incident',
    AI_DESCRIPTION:
      'Describe what happened, where, and when — e.g.There was a small fire in the electrical room near Balestier Road, Novena.',
    LOCATION_DESCRIPTION: 'Additional details about the location',
  },
  TAB_LABEL: {
    ALL: 'All',
    UNREAD: 'Unread',
  },
  UPDATES_PANEL: {
    UPDATES: 'Updates',
    MARK_AS_READ: 'Mark all as Read',
    ALL: 'All',
    UNREAD: 'Unread',
    ALL_KEY: 'all',
    UNREAD_KEY: 'unread',
    NO_NOTIFICATIONS: 'No notifications',
    NO_UNREAD_NOTIFICATIONS: 'No unread notifications',

    // Notification titles
    NEW_INCIDENT_TITLE: 'New Incident',
    UPDATE_TITLE: 'Update',

    CREATED_AT: 'created at',

    // Status labels
    STATUS_CLOSED: 'Closed',
    STATUS_IN_PROGRESS: 'In Progress',

    // Change descriptions
    STATUS_CHANGE: 'Status',
    SEVERITY_CHANGE: 'Severity',
    TYPE_CHANGE: 'Type',
    DESCRIPTION_UPDATED: 'Description updated',
    RESPONDERS_ADDED: 'responder(s) added',
    RESPONDERS_REMOVED: 'responder(s) removed',
    RESPONDERS_UPDATED: 'Responders updated',
    LOCATION_CHANGED: 'Location changed',
    UPDATED_DEFAULT: 'Updated',

    // Default values
    DEFAULT_TYPE: 'Incident',
    UNKNOWN_LOCATION: 'Unknown location',
  },
  ALERTS_PANEL: {
    CREATE_INCIDENT: 'Create Incident',
    VIEW: 'View',
  },
  MAP_STATUSES: {
    ALL: 'all',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    ACTIVATED: 'activated',
    AVAILABLE: 'available',
    OFFLINE: 'offline',
    RESOLVED: 'resolved',
  },
  CREATE_INCIDENT: {
    CREATE_INCIDENT: 'Create Incident',
    CANCEL: 'Cancel',
    COMPLETE: 'Complete',
    SELECT_RESPONDERS: 'Select Responders',
  },
  EDIT_INCIDENT: {
    EDIT_INCIDENT: 'Edit Incident',
    CANCEL: 'Cancel',
    COMPLETE: 'Complete',
    SELECT_RESPONDERS: 'Select Responders',
    SAVE: 'Save changes',
  },
  MAP_MESSAGE_TYPES: {
    MAP_READY: 'MAP_READY',
    MAP_CLOSED: 'MAP_CLOSED',
    PING_MAP: 'PING_MAP',
    CENTER_MAP: 'CENTER_MAP',
    SHOW_INCIDENTS: 'SHOW_INCIDENTS',
    SHOW_RESPONDERS: 'SHOW_RESPONDERS',
    GEOLOC_SELECTED: 'GEOLOC_SELECTED',
    INCIDENT_SELECTED: 'INCIDENT_SELECTED',
    RESPONDER_SELECTED: 'RESPONDER_SELECTED',
    CLEAR_SELECTION: 'CLEAR_SELECTION',
  },
  MULTI_SELECT: {
    PLACEHOLDER: 'Select options',
    EVENTLISTENERS: {
      MOUSEDOWN: 'mousedown',
    },
    NO_RESPONDER_AVAILABLE: 'No Responder Available.',
  },
  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Search...',
    NO_MESSAGES_YET: 'No messages yet',
    IS_SPEAKING: 'is speaking...',
    ONLINE: 'online',
    OFFLINE: 'offline',
    TRANSCRIBING: 'Transcribing...',
    NO_CHAT_FOUND: 'No chats found',
    NO_CHAT_SELECTED_TITLE: 'No chat selected',
    NO_CHAT_SELECTED_DESCRIPTION: 'Select a user or group from the sidebar to start messaging',
    INPUT_PLACEHOLDER_DEFAULT: 'Write a message...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Add a caption...',
    IS_TALKING: 'is talking...',
    PTT_ACTIVE: 'PTT Active - Speaking...',
    PTT_LOCKED: 'PTT Locked - Click to release',
    PTT_SLIDE_HINT: 'Slide up to lock',
    PTT_RELEASE_AND_SEND: 'Release & Send',
    ATTACHED_FILES_TITLE: 'Attached Files',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Failed to transcribe audio',
    NO_CHAT_MESSAGE: 'No chat message',
    FALLBACK_MESSAGE: ' To start a chat, type your message or use the PTT/PTV feature.',
    INCOMING_VIDEO_CALL: 'Incomming PTV...',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    ERROR: 'Error:',
    NO_MESSAGES_FOUND_FOR: 'No messages found for',
    SYSTEM_MESSAGE: 'System message',
    //Enums for comparasion
    GROUP: 'group',
    AUDIO: 'audio',
    VIDEO: 'video',
    FILE: 'file',
    ME: 'me',
    IMAGE: 'image',
    TEXT: 'text',
    CHAT: 'chat',
    NONE: 'none',
    PROFILE: 'profile',
    SEARCH: 'search',
    COMPLETED: 'completed',
    RESOLVED: 'resolved',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Unknown',
    THEM: 'them',
  },

  SYSTEM_KEYWORDS: [
    'has accepted the incident',
    'Incident has been updated',
    'Incident has been resolved',
    'You have joined the group',
  ],

  TRANSLATABLE_VALUES: [
    'Today',
    'Yesterday',
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'members',
    GROUP_MEMBERS_TITLE: 'Group Members',
    USERNAME_LABEL: 'Username',
    EMAIL_LABEL: 'Email',
    MEMBER_FALLBACK_NAME: 'Member',
    MEMBER_FALLBACK_ID: 'Member',
  },
  // PTT Related Constants
  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'PTT recording started for {userName}',
      STOP_RECORDING: 'PTT audio sent to {userName}',
      NO_AUDIO_DATA: 'No audio data received from SDK',
      TRANSCRIPTION_SUCCESS: 'Audio transcription completed',
      TRANSCRIPTION_FAILED: 'Transcription failed, sending audio without text',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'en',
      RESPONSE_FORMAT: 'text',
    },
  },
  // Common UI Text
  UI: {
    UNKNOWN: 'unknown',
    DASH: '-',
  },

  MESSAGE: {
    INCIDENT_CREATION_SUCCESS: 'Incident created successfully.',
    INCIDENT_CREATION_ERROR: 'Failed to create incident. Please check your connection and try again.',
    SUCCESS: 'success',
    ERROR: 'error',
    INCIDENT: 'incident',
  },

  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'activated SOS alert',
    LOCATION_LABEL: 'Location',
    INCIDENT_LABEL: 'Incident',
    LAST_STATUS_LABEL: 'Last Status',
    ASSIST_BUTTON: 'Assist',
  },

  SETTINGS: {
    TITLE: 'Settings',
    SUBTITLE: 'Select your preferred language options.',
    LANGUAGE_DISPLAY: 'Language Display',
    AUTO_TRANSLATE_TITLE: 'Incoming message translation',
    AUTO_TRANSLATE_DESCRIPTION: 'This option automatically translates incoming messages to your selected language.',
    SAVE_BUTTON: 'Save Changes',
  },

  PERMISSIONS: {
    MICROPHONE_KEY: 'microphone',
    GEOLOCATION_KEY: 'geolocation',
    NOTIFICATIONS_KEY: 'notifications',
    CAMERA_KEY: 'camera',
  },

  STATES: {
    GRANTED: 'granted',
    DENIED: 'denied',
    PROMPT: 'prompt',
  },

  ERRORS: {
    CHECK_PERMISSION: 'Error checking permission',
    REQUEST_PERMISSION: 'Error requesting permission',
  },

  PERMISSION_DIALOG: {
    // Permission identifiers (used for checks)
    MICROPHONE_KEY: 'microphone',
    CAMERA_KEY: 'camera',
    NOTIFICATIONS_KEY: 'notifications',
    GEOLOCATION_KEY: 'geolocation',

    // Permission-specific translation keys
    MICROPHONE: {
      TITLE: 'PERMISSION_DIALOG.MICROPHONE.TITLE',
      DESCRIPTION: 'PERMISSION_DIALOG.MICROPHONE.DESCRIPTION',
      INSTRUCTION: 'PERMISSION_DIALOG.MICROPHONE.INSTRUCTION',
      BUTTON_LABEL: 'PERMISSION_DIALOG.MICROPHONE.BUTTON_LABEL',
    },
    CAMERA: {
      TITLE: 'PERMISSION_DIALOG.CAMERA.TITLE',
      DESCRIPTION: 'PERMISSION_DIALOG.CAMERA.DESCRIPTION',
      INSTRUCTION: 'PERMISSION_DIALOG.CAMERA.INSTRUCTION',
      BUTTON_LABEL: 'PERMISSION_DIALOG.CAMERA.BUTTON_LABEL',
    },
    NOTIFICATIONS: {
      TITLE: 'PERMISSION_DIALOG.NOTIFICATIONS.TITLE',
      DESCRIPTION: 'PERMISSION_DIALOG.NOTIFICATIONS.DESCRIPTION',
      INSTRUCTION: 'PERMISSION_DIALOG.NOTIFICATIONS.INSTRUCTION',
      BUTTON_LABEL: 'PERMISSION_DIALOG.NOTIFICATIONS.BUTTON_LABEL',
    },
    GEOLOCATION: {
      TITLE: 'PERMISSION_DIALOG.GEOLOCATION.TITLE',
      DESCRIPTION: 'PERMISSION_DIALOG.GEOLOCATION.DESCRIPTION',
      INSTRUCTION: 'PERMISSION_DIALOG.GEOLOCATION.INSTRUCTION',
      BUTTON_LABEL: 'PERMISSION_DIALOG.GEOLOCATION.BUTTON_LABEL',
    },

    // Shared/common text keys
    HEADINGS: {
      WHAT_TO_DO: 'PERMISSION_DIALOG.HEADINGS.WHAT_TO_DO',
      ADDITIONAL_REQUIRED: 'PERMISSION_DIALOG.HEADINGS.ADDITIONAL_REQUIRED',
      GENERIC_PERMISSION_TITLE: 'PERMISSION_DIALOG.HEADINGS.GENERIC_PERMISSION_TITLE',
      GENERIC_DESCRIPTION: 'PERMISSION_DIALOG.HEADINGS.GENERIC_DESCRIPTION',
      GENERIC_INSTRUCTION: 'PERMISSION_DIALOG.HEADINGS.GENERIC_INSTRUCTION',
    },

    // Fallback
    DEFAULT_BUTTON_LABEL: 'PERMISSION_DIALOG.DEFAULT_BUTTON_LABEL',
  },
};

export const severityValues = [
  {
    value: 4,
    label: 'Critical',
    dotColor: 'bg-icon-error',
  },
  {
    value: 3,
    label: 'High',
    dotColor: 'bg-chart-2',
  },
  {
    value: 2,
    label: 'Medium',
    dotColor: 'bg-chart-4',
  },
  {
    value: 1,
    label: 'Low',
    dotColor: 'bg-interactive',
  },
  {
    value: 0,
    label: 'Minimal',
    dotColor: 'bg-icon-muted',
  },
];
